import React from 'react';
import { SearchResultContainer, ResultItem, StatusMessage } from './style';

const SearchResult = ({ data, loading, isValue, handleAddDevice }) => {
  if (isValue && !loading && !data.length) {
    return <StatusMessage>No results</StatusMessage>;
  }

  if (!data.length) {
    return null;
  }

  return (
    <SearchResultContainer
      aria-label="Device search result"
    >
      {data.map(d => (
        <ResultItem
          key={d.data.id}
          onClick={() => handleAddDevice(d)}
        >
          {d.label}
        </ResultItem>))}
    </SearchResultContainer>
  );
};

export default SearchResult;
